import { create } from 'zustand';
import { CheckoutType, intialCheckoutState } from '../app/types/checkoutType';

// Interfaccia per lo store
interface CheckoutState {
  checkout: CheckoutType;
  // Actions
  setCheckout: (checkout: CheckoutType) => void;
  updateCheckout: (updates: Partial<CheckoutType>) => void;
  resetCheckout: () => void;
  // Selectors per convenienza
  hasProduct: () => boolean;
  hasError: () => boolean;
}

// Store Zustand per il checkout
export const useCheckoutStore = create<CheckoutState>()((set, get) => ({
  checkout: intialCheckoutState,
  
  // Setta il checkout completo (equivalente a updateProductCheckout action di Redux)
  setCheckout: (checkout: CheckoutType) => set({ checkout }),
  
  // Aggiorna parzialmente il checkout
  updateCheckout: (updates: Partial<CheckoutType>) => set((state) => ({
    checkout: { ...state.checkout, ...updates }
  })),
  
  // Reset del checkout allo stato iniziale
  resetCheckout: () => set({ checkout: intialCheckoutState }),
  
  // Selector per verificare se c'è un prodotto
  hasProduct: () => {
    const { checkout } = get();
    return checkout.prodotto !== undefined;
  },
  
  // Selector per verificare se c'è un errore
  hasError: () => {
    const { checkout } = get();
    return checkout.error !== undefined && checkout.error !== null;
  }
}));

// Export dello stato iniziale per compatibilità
export { intialCheckoutState }; 